import React from "react";
import { useSelector } from "react-redux";
import GeoFence from "./GeoFence";
import NexusGeoFence from "../Nexus-GeoFence/NexusGeo";

// Accounts linked to TraKing (MASTERCOMP.NexusCompId) manage their fences in
// TraKing, so Administration > Geofence Management shows the Nexus page for
// them (its Add / Edit go to the Nexus details page). The Nexus operator
// (MCID 59) and every account that isn't linked to TraKing keep this page.
const GeoFenceSwitch = () => {
  const usesTraking = useSelector((state) => {
    const u = state?.authTracking?.userInfo;
    return Boolean(u?.NexusCompId) && u?.MCID !== 59;
  });
  return usesTraking ? <NexusGeoFence /> : <GeoFence />;
};

export default GeoFenceSwitch;
